import { render, staticRenderFns } from "./indexStatis.vue?vue&type=template&id=5f95d26c&scoped=true&"
import script from "./indexStatis.vue?vue&type=script&lang=js&"
export * from "./indexStatis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f95d26c",
  null
  
)

export default component.exports